import { checkUploadStatus } from "./streamsapi_bridge";

export function sanitizeAndLowercase(text) {
    if (text && text.trim() !== "") {
        return text.replace(/\\s+/g, ' ').trim().toLowerCase(); // Convert to lowercase
    } else {
        return "";
    }
}

export const normalizePhoneNumber = (e) => {
    try {
        if (e?.target?.value) {
            e.target.value = e.target.value.replace(/[+\-\s]/g, '');
        }
    } catch (error) {
        console.error("normalizePhoneNumber error:", error);
    }
};

export function getStreamsProductName(){
    try {
        return `${JSON.parse(sessionStorage.getItem("admin_session"))?.streams_productname ?? "Streams.AI"}`
    } catch (error) {
        return "Streams.AI";
    }
}

export function getSbProductName(){
    try {
        return `${JSON.parse(sessionStorage.getItem("admin_session"))?.sb_productname ?? "SmartBox"}`
    } catch (error) {
        return "SmartBox";
    }
}

export async function getImpExpStatus() {
    const response = await checkUploadStatus(JSON.parse(sessionStorage.getItem("admin_session")).siteid, 1);
    const data = await response.json();
    return data?.is_progress && data?.is_progress === 1 ? true : false;
}
/**
 * Returns a structured result describing the current import/export progress state.
 *
 * { status: 0 }
 *   → No operation in progress. Caller may proceed normally.
 *
 * { status: 1, isOwnUser: true }          ← no userInfo
 *   → The logged-in user started the operation (Case 1).
 *     Caller should offer a redirect to the import page.
 *
 * { status: 1, isOwnUser: false, userInfo }
 *   → Another user/account started the operation (Case 2).
 *     userInfo: { is_account: bool, name: string }
 *     Caller should show a blocking warning with the initiator's name.
 */
export async function getImpExpStatusNew() {
    const response = await checkUploadStatus(JSON.parse(sessionStorage.getItem("admin_session")).siteid, 1);
    const data = await response.json();

    if (!data?.is_progress || data.is_progress !== 1) {
        return { status: 0 };
    }

    if (data?.isuser_imp_export === true) {
        // Case 1: own user initiated → redirect popup
        return { status: 1, isOwnUser: true };
    }

    // Case 2: another user/account initiated → warning popup
    return {
        status: 1,
        isOwnUser: false,
        userInfo: data?.user_info ?? {}
    };
}